import { render, staticRenderFns } from "./ItemAttachments.vue?vue&type=template&id=087852ae&scoped=true"
import script from "./ItemAttachments.vue?vue&type=script&lang=ts"
export * from "./ItemAttachments.vue?vue&type=script&lang=ts"
import style0 from "./ItemAttachments.vue?vue&type=style&index=0&id=087852ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087852ae",
  null
  
)

export default component.exports